export default {
  image: 'https://www.priceline.com/static-pages/images/Artboard.png',
  url: 'https://www.priceline.com',
  name: 'vacationpackages',
  description:
    'Save up to 625 dollars when you book your flight and hotel together! ' +
    'Priceline&trade; Vacation packages with exclusive deals on airline tickets ' +
    '& hotels worldwide. How much will you save?',
  title: {
    '/flights': 'Flights: Find Cheap Flights & Airfares | Priceline',
    '/hotels': 'Hotels: Find Cheap Hotel Rooms & Discount Hotels | Priceline',
    '/vacationpackages':
      'Packages: Find bundle deals on a hotel, flight, & rental car vacation | Priceline',
    '/vip': 'Priceline VIP - Unlock savings, deals & travel perks | Priceline'
  }
}
